import 'react-big-calendar/lib/css/react-big-calendar.css'
import styled from 'styled-components'

export const ShowHoursContainer = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
  display: flex;
  justify-content: flex-end;
  width: max-content;
`

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: scroll;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    overflow-x: visible;
  }
`

export const LoaderWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.powder};
  z-index: 160;
  opacity: 0.5;
  display: flex;
  justify-content: center;

  .wrapper {
    padding-top: 20vh;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 120px);
    height: calc(100% - 180px);
  }
`

export const TimeGridContainer = styled.div`
  height: 100vh;

  .rbc-time-view .rbc-allday-cell {
    display: none;
  }

  .rbc-event-label {
    display: none;
  }

  .rbc-time-view {
    border: 0;
    overflow: auto;
  }

  .rbc-time-header {
    background-color: #f4f8fe;
    z-index: 1;
    position: sticky;
    top: 0;
  }

  .rbc-header {
    border: 0;
    border-right: 1px solid ${({ theme }) => theme.palette.blue20};
    position: relative;

    &:last-child {
      border: 0;
    }
  }

  .rbc-time-header-content {
    border-left: 1px solid ${({ theme }) => theme.palette.blue20};
  }

  .rbc-events-container {
    border: 0;
    border-left: 1px solid ${({ theme }) => theme.palette.blue20};
  }

  .rbc-time-header-gutter {
    width: 80px !important;
    max-width: 80px !important;
  }

  .rbc-time-gutter {
    width: 80px;
  }

  .rbc-time-content {
    overflow-y: initial;
    border-top: 4px solid ${({ theme }) => theme.palette.blue20};
  }

  .rbc-timeslot-group {
    border-bottom: 2px dashed ${({ theme }) => theme.palette.blue20};

    .rbc-label {
      position: absolute;
      z-index: 1;
      font-size: ${({ theme }) => theme.fontSize.xxxs};
      font-weight: ${({ theme }) => theme.fontWeight.regular};
      position: absolute;
      margin-top: -8px;
      background-color: #f4f8ff;
      padding-right: 20px;
    }

    &:nth-child(2n + 0) {
      border-bottom: 1px solid ${({ theme }) => theme.palette.blue20};
    }

    &:nth-child(4n + 0) {
      border-bottom: 4px solid ${({ theme }) => theme.palette.blue20};
    }

    &:nth-child(4n + 1) {
      .rbc-label {
        font-weight: ${({ theme }) => theme.fontWeight.bold};
      }
    }
  }

  .event-slot {
    border-color: ${({ theme }) => theme.palette.warning100};
    border: 2px solid ${({ theme }) => theme.palette.warning100};
    border-top: 6px solid ${({ theme }) => theme.palette.warning100};
    background-color: ${({ theme }) => theme.palette.warning10};
    color: ${({ theme }) => theme.palette.charcoal};
    font-size: ${({ theme }) => theme.fontSize.xxxs};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    line-height: 1.33;
    letter-spacing: 0.42px;

    svg {
      font-size: ${({ theme }) => theme.fontSize.xs};
      margin-right: ${({ theme }) => theme.space.xxs};
      margin-bottom: ${({ theme }) => theme.space.xxs};
      margin-left: ${({ theme }) => theme.space.xxxs};
    }

    .desc {
      font-weight: ${({ theme }) => theme.fontWeight.regular};
    }

    &.f2f {
      svg {
        color: ${({ theme }) => theme.palette.purple100};
      }
    }

    &.base {
      border-color: ${({ theme }) => theme.palette.green100};
      background-color: ${({ theme }) => theme.palette.green10};
      cursor: default;
    }

    &.timeoff {
      border-color: ${({ theme }) => theme.palette.gray100};
      background-color: ${({ theme }) => theme.palette.white};
    }

    &.past-event {
      cursor: default;
    }

    &.cursor-pointer {
      cursor: pointer;
    }
  }

  div[style*='width: 85%'] {
    width: 50% !important;
    left: 0 !important;

    &.timeoff {
      width: 95% !important;
      left: 0 !important;
    }

    &.availability {
      width: 100% !important;
    }
  }

  div[style*='width: 50%'] {
    width: 50% !important;
    left: 0 !important;

    &.timeoff {
      width: 95% !important;
      left: 0 !important;
    }

    &.availability {
      width: 100% !important;
    }
  }

  div[style*='width: 100%'] {
    &.timeoff {
      width: 95% !important;
      left: 0 !important;
    }
  }

  width: max-content;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 100%;
  }
`

export const SubHeader = styled.div`
  .holder {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 52vh;

    .action-btns {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: max-content;

      .bulkdelete-btn {
        padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
        margin: ${({ theme }) => `${theme.space.md} 0 ${theme.space.md}`};
      }
    }
  }

  .spacer {
    display: block;
  }

  div[role='radiogroup'] {
    margin-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    .holder {
      flex-direction: row;
      width: 100%;
      align-items: baseline;

      .action-btns {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        width: max-content;

        .bulkdelete-btn {
          padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
          margin: ${({ theme }) => `0 0 0 ${theme.space.md}`};
        }
      }
    }

    .spacer {
      display: none;
    }
  }
`

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 350px;
  margin-top: ${({ theme }) => theme.space.xxs};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: max-content;
    margin-top: ${({ theme }) => theme.space.md};
  }

  .icon {
    cursor: pointer;

    &:first-child {
      margin-right: ${({ theme }) => theme.space.xs};
    }

    &:last-child {
      margin-left: ${({ theme }) => theme.space.xs};
    }
  }

  .react-datepicker-popper {
    z-index: 2;
  }
`

export const DateLabel = styled.div`
  text-transform: uppercase;
  text-align: left;

  .date {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-bottom: ${({ theme }) => theme.space.xxs};
  }

  .day {
    font-size: ${({ theme }) => theme.fontSize.xxs};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
  }
`

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => `${theme.space.md} ${theme.space.xs}`};
  background-color: #f4f8fe;

  &.is-today {
    background-color: #eaf6ff;
  }

  ${DateLabel} {
    text-align: center;
    display: flex;
    align-items: baseline;
    padding-left: ${({ theme }) => theme.space.md};
    padding-right: ${({ theme }) => theme.space.md};

    .date {
      margin-right: ${({ theme }) => theme.space.xxxs};
    }

    .day {
      margin-left: ${({ theme }) => theme.space.xxxs};
    }
  }

  svg {
    margin-top: ${({ theme }) => theme.space.xxs};
    font-size: ${({ theme }) => theme.fontSize.xl};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;

    ${DateLabel} {
      text-align: left;
      display: initial;
      padding-left: 0;
      padding-right: 0;

      .date {
        margin-right: ${({ theme }) => theme.space.xxxs};
      }

      .day {
        margin-left: ${({ theme }) => theme.space.xxxs};
      }
    }
  }
`
